import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';

import {
  faRocket,
  faRuler,
  faList,
  faChartLine,
  faDollarSign,
} from '@fortawesome/free-solid-svg-icons';

import Link from '../../../../../components/Link';
import PageLayout from '../../../../../components/PageLayout';

import ShadowerLink from '../../../../../components/ShadowerLink';

import Navbar from '../../../../../components/Handbook/Navbar';

import s from '../../HandbookPage.scss';

class HowPaymentWorksPage extends React.Component {
  render() {
    return (
      <PageLayout className={s.page}>
        <div className={s.container}>
          <div className={s.navbar}>
            <div className={s.title}>Shadowing Handbook</div>
            <Navbar
              navbarIcon={faRocket}
              navbarSection="Getting Started"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/welcome-to-shadower"
                  >
                    Welcome to Shadower
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/how-shadower-works"
                  >
                    How Shadower Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/working-with-businesses"
                  >
                    Working with Businesses
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/getting-started/shadowing-guidelines"
                  >
                    Shadowing Guidelines
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faRuler}
              navbarSection="Planning a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/choosing-a-topic"
                  >
                    Choosing a Topic
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/interactivity-level"
                  >
                    Interactivity Level
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/session-type"
                  >
                    Session Type
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/planning-a-session/providing-resources"
                  >
                    Providing Resources
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faList}
              navbarSection="Managing a Session"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/expectations"
                  >
                    Expectations
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/session-flow"
                  >
                    Session Flow
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/managing-a-session/maximizing-your-time"
                  >
                    Maximizing Your Time
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faChartLine}
              navbarSection="Promoting Your Profile"
              navbarSubsection={
                <div>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-the-platform-works"
                  >
                    How the Platform Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/optimizing-your-profile"
                  >
                    Optimizing Your Profile
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/marketing-yourself"
                  >
                    Marketing Yourself
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/promoting-your-profile/how-to-build-a-following"
                  >
                    How to Build a Following
                  </Link>
                </div>
              }
            />

            <Navbar
              navbarIcon={faDollarSign}
              navbarSection="Earning Revenue"
              navbarSubsection={
                <div>
                  <Link
                    className={cx(s.link, s.active)}
                    to="/handbook/earning-revenue/how-payment-works"
                  >
                    How Payment Works
                  </Link>
                  <Link
                    className={s.link}
                    to="/handbook/earning-revenue/connecting-with-the-community"
                  >
                    Connecting with the Community
                  </Link>
                </div>
              }
              overrideDefault
            />

            <Link className={s.newProfileLink} to="/user/profiles/new">
              Create a shadowing profile
            </Link>
          </div>

          <div className={s.explanation}>
            <Panel>
              <Panel.Heading>
                <div>Earning Revenue</div>
              </Panel.Heading>
              <Panel.Body>
                <div className={s.handbookTitle}>A guide for experts</div>
                <div className={s.subsectionTitle}>How Payment Works</div>
                <p>
                  Shadower will follow similar pricing models to other
                  service-based, sharing-economy platforms. Our ultimate goal is
                  to share knowledge and make education affordable, effective
                  and accessible to the general public. We want to provide users
                  with the best experience possible while being able to still
                  improve the platform, address issues and afford hosting,
                  payment processing and domain management, as well as
                  strengthen the shadowing community by expanding into other
                  areas of education.
                </p>
                <div className={s.contentContainer}>
                  <div>
                    <strong>How Shadower Makes Money</strong>
                  </div>
                  <p>
                    A simple, upfront service fee is charged to both the expert
                    and shadower upon booking a shadowing session.
                  </p>

                  <ul>
                    <li>
                      Expert Service Fee
                      <p>
                        A service fee of 10 percent is automatically deducted
                        from the expert's payout.
                      </p>
                    </li>

                    <li>
                      Shadower Service Fee
                      <p>
                        A booking fee of 10 percent is automatically added to
                        the price of the session.
                      </p>
                    </li>
                  </ul>
                </div>
                <div className={s.contentContainer}>
                  <div>
                    <strong>How Shadower Pays its Experts</strong>
                  </div>
                  <p>
                    Shadower pays its experts on a weekly basis, directly into
                    your bank account with all money handled securely through
                    Stripe. You will receive 90 percent of whatever you charge
                    your shadowers.
                  </p>
                </div>
                <div className={s.contentContainer}>
                  <div>
                    <strong>Non-Profits</strong>
                  </div>
                  <p>
                    At Shadower, we believe in putting the community first. If
                    you operate or work for a registered 501(c)(3), let us know
                    and we will waive our fees entirely, so 100 percent of the
                    money you earn will support your organization.
                  </p>
                </div>
                Check out the <Link to="/help">Help Center</Link> if you have
                questions regarding payouts.
                <ShadowerLink
                  className={s.nextLink}
                  to="/handbook/earning-revenue/connecting-with-the-community"
                >
                  Next {'>'}
                </ShadowerLink>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </PageLayout>
    );
  }
}

export default withStyles(s)(HowPaymentWorksPage);
